import React, { useState } from 'react';
import Button from '~/src/components/Button';
import { PlanUpgradeOption } from '~/src/entities/subscription/types';

interface PlanChangeOptionsCardProps {
  plan: PlanUpgradeOption;
  onPreview: (plan: PlanUpgradeOption) => Promise<void>;
}

const PlanChangeOptionsCard = ({
  plan,
  onPreview,
}: PlanChangeOptionsCardProps) => {
  const [loading, setLoading] = useState(false);

  const handlePreview = async () => {
    setLoading(true);

    try {
      await onPreview(plan);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border border-gray-200 rounded-lg p-3">
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1 mr-4">
          <h4 className="text-base font-semibold text-gray-900 break-words">
            {plan.display_name}
          </h4>
          <p className="text-xs text-gray-600 mt-1">
            {plan.billing_cycle} billing cycle
          </p>
        </div>
        <div className="text-right flex-shrink-0">
          <div className="text-lg font-bold text-gray-900">
            ${(plan.license_rate / 100).toFixed(2)}
          </div>
          <div className="text-xs text-gray-600">per license</div>
        </div>
      </div>

      <div className="mb-2">
        <div className="text-xs text-gray-600 mb-1">Features:</div>
        <div className="flex flex-wrap gap-1">
          {plan.feature_set.slice(0, 2).map((feature, index) => (
            <span
              key={index}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800 break-words"
            >
              {feature
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (l) => l.toUpperCase())}
            </span>
          ))}
          {plan.feature_set.length > 2 && (
            <span className="text-xs text-gray-500">
              +{plan.feature_set.length - 2} more
            </span>
          )}
        </div>
      </div>

      <div className="flex justify-end">
        <Button
          onClick={handlePreview}
          primary
          disabled={loading}
          className="px-4 py-2 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Loading preview...' : 'Upgrade'}
        </Button>
      </div>
    </div>
  );
};

export default PlanChangeOptionsCard;
